<template>
  <div class="abilityBroker">
    <div class="middle">
      <div class="middleItem">
        <div>
          <img src="../assets/images/picture_26.png" alt="">
        </div>
        <div>
          <div class="words">
            <div class="fz14">
              <span class="fz18 c333">黄丽娜</span><br>
              <span class="highlight">幸运人保险事务所创始人</span><br>
              连续七年国际IDA龙奖<br>
              连续蝉联三届MDRT会员<br>
              浙江分公司单件保费最高记录创造者<br>
              浙江分公司年度团队业绩排名赛第一名
            </div>
          </div>
        </div>
      </div>
      <div class="middleItem">
        <div>
          <img src="../assets/images/picture_27.png" alt="">
        </div>
        <div>
          <div class="words">
            <div class="fz14">
              <span class="fz18 c333">邵湄清</span><br>
              <span class="highlight">从业20载</span><br>
              连续十年国际IDA龙奖<br>
              连续蝉联三届美国百万圆桌MDRT COT<br>
              浙江分公司百万保单组合之星<br>
              浙江分公司当月最高个人收入创造者<br>
              浙江分公司年度最高个人净业绩创造者
            </div>
          </div>
        </div>
      </div>
      <div class="middleItem">
        <div>
          <img src="../assets/images/picture_28.png" alt="">
        </div>
        <div>
          <div class="words">
            <div class="fz14">
              <span class="fz18 c333">沈月清</span><br>
              <span class="highlight">桐乡市女企业家</span><br>
              壹心桐乡分公司创始人，圆梦区总监<br>
              2019年~2020年连续两年达成MDRT<br>
              规划干万级保单，家企隔离
            </div>
          </div>
        </div>
      </div>
      <div class="middleItem">
        <div>
          <img src="../assets/images/picture_29.png" alt="">
        </div>
        <div>
          <div class="words">
            <div class="fz14">
              <span class="fz18 c333">陈伟</span><br>
              <span class="highlight">聚星保险事务所创始人</span><br>
              曾获全国年度增员王<br>
              全国高峰会会员<br>
              连续5年入围IQA国际品质奖
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'abilityBroker',
    components: {},
    data() {
      return {
      }
    },
    computed: {},
    created() {},
    mounted() {},
    methods: {}
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .abilityBroker {
    width: 1200px;
    margin: 0 auto;
    &>div {
      margin-top: 40px;
    }

    .middle {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .middleItem {
        width: 267px;
        height: 432px;
        box-shadow: 0px 5px 30px 0px rgba(0, 0, 0, 0.1);

        img {
          width: 267px;
        }
        .words{
          line-height: 26px;
          text-align: center;
          color: #666666;
          padding-top: 10px;
          .highlight{
            display: inline-block;
            color: #EAA12C;
            padding-top: 6px;
          }
        }

      }
    }

  }
</style>